var EnvNgApp;
(function (EnvNgApp) {
    var Common;
    (function (Common) {
        var Collections;
        (function (Collections) {
            var Dictionary = /** @class */ (function () {
                function Dictionary() {
                    this._keys = [];
                    this._values = [];
                }
                //constructor(init: { key: string; value: any; }[]) {
                //    for (var x = 0; x < init.length; x++) {
                //        this[init[x].key] = init[x].value;
                //        this._keys.push(init[x].key);
                //        this._values.push(init[x].value);
                //    }
                //}
                Dictionary.prototype.add = function (key, value) {
                    this[key] = value;
                    this._keys.push(key);
                    this._values.push(value);
                };
                Dictionary.prototype.remove = function (key) {
                    var index = this._keys.indexOf(key, 0);
                    this._keys.splice(index, 1);
                    this._values.splice(index, 1);
                    delete this[key];
                };
                Dictionary.prototype.keys = function () {
                    return this._keys;
                };
                Dictionary.prototype.values = function () {
                    return this._values;
                };
                Dictionary.prototype.containsKey = function (key) {
                    if (typeof this[key] === "undefined") {
                        return false;
                    }
                    return true;
                };
                Dictionary.prototype.toLookup = function () {
                    return this;
                };
                return Dictionary;
            }());
            Collections.Dictionary = Dictionary;
        })(Collections = Common.Collections || (Common.Collections = {}));
    })(Common = EnvNgApp.Common || (EnvNgApp.Common = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=dictionary.js.map